module.exports = __webpack_public_path__ + "media/images/logout-display-5616d8fe17d94e3c7aed990bf1a9a9d0.svg";